import { render, staticRenderFns } from "./PaymentDetailsPage.vue?vue&type=template&id=7af2872e&"
import script from "./PaymentDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./PaymentDetailsPage.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentDetailsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports